<template>
  <span>
    <b-popover
      triggers="hover focus"
      :class="['hover-popover', extraClass]"
      :placement="placement"
      teleport-to="body"
    >
      <template #target>
        <font-awesome-icon :icon="icon" class="hover-popover-icon" />
      </template>
      <slot>{{ hoverText }}</slot>
    </b-popover>
  </span>
</template>
<script>

export default {
  name: 'HoverIcon',
  props: {
    icon: {
      type: [String, Array],
      required: true
    },
    hoverText: {
      type: String,
      default: ''
    },
    extraClass: String,
    placement: String
  }
}
</script>
<style>
  .hover-popover {
    z-index: 1105;
    .popover-body {
      overflow-y: auto;
      white-space:pre-wrap;
      max-height: 80vh;
    }
  }
  .hover-popover-icon {
    margin-left: 5px;
    color: #555;
    cursor: help;
  }
</style>
